import React, { useContext, useState, useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import ManualsTable from "../../../components/manuals-table/ManualsTable";
import { fetchFiles } from "../../../api/files";

const Manuals = () => {
  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchFiles("Manual").then((result) => {
      if (!result?.data?.data?.documents) return;
      setFiles([...result.data.data.documents]);
      setLoading(false);
    });
  }, []);
  
  return (
    <Row>
      <Col col={12} className="mb-4">
        <ManualsTable files={files} setFiles={setFiles} loading={loading} />
      </Col>
    </Row>
  );
};

export default Manuals;
